module.exports = __webpack_public_path__ + "img/mail.240aa214.svg";